import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BillingFormComponent } from './billing-form.component';
import { PriceTiersModule } from '../../../components/price-tiers/price-tiers.module';
import { PriceTiersComponent } from '../../../components/price-tiers/price-tiers.component';
import { BackButtonModule } from 'src/app/components/back-button/back-button.component.module';
import { CreditCardDirectivesModule } from 'angular-cc-library';

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild([{path: '', component: BillingFormComponent}]),
    TranslateModule,
    PriceTiersModule,
    BackButtonModule,
    CreditCardDirectivesModule
  ],
    entryComponents: [PriceTiersComponent],
    declarations: [BillingFormComponent]
})
export class BillingFormModule { }
